<template>
  <div class="row">
    <div class="label">
      {{ label }}

      <t-tooltip v-if="tips" class="item" :content="tips" placement="top">
        <icon name="help-circle" style="margin-bottom: 2px" />
      </t-tooltip>
    </div>

    <div class="form-item-wrapper">
      <div class="form-item">
        <slot></slot>
      </div>

      <slot name="extraLine"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'form-item',
  components: {},
  data() {
    return {};
  },
  props: {
    label: {
      type: String,
    },
    tips: {
      type: String,
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  align-items: flex-start;
  margin-top: 20px;

  .label {
    width: 100px;
    min-width: 100px;
    color: #888888;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    text-align: left;

    .info {
      cursor: pointer;
    }
  }

  .form-item-wrapper {
    flex: 1;
    &:hover {
      //background-color: #fafafa;
    }

    .form-item {
      position: relative;
    }
  }
}
</style>
